import { Box, Grid } from '@material-ui/core';
import { useFormState, useForm } from 'react-final-form';
import _ from 'lodash';
import { useMemo, useCallback, useEffect } from 'react';
import { v4 as uuid } from 'uuid';

import QCXFinalBondManager from '../../../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManager'
import QCXFinalTextField from '../../../../shared-components/final-text-field/QCXFinalTextField';
import SelectFundamentosOpcionais from './SelectFundamentosOpcionais';

export default function QCXSelectManyFundamentosObrigatorios({
  name="",
  values={},
  disabled = false,
  fundamentosGrouped = [],
  ...restProps
}) {

  const form = useForm();

  useEffect(() => {

    if (fundamentosGrouped && fundamentosGrouped.length) {
      let tratamentosObrigatorios = [];
      fundamentosGrouped.forEach(fundamentoSelecionado => {

        const fundamento = {
          id: fundamentoSelecionado.id,
          codigo: fundamentoSelecionado.tipo,
          nome: fundamentoSelecionado.nome,
        }
  
        const novosTratamentos = fundamentoSelecionado?.tratamentos.map((tratamento) => (
          {
            id: uuid(),
            codigo: fundamentoSelecionado.id,
            fundamento: {...fundamento},
            regime: {...tratamento.regime},
            tributo: {...tratamento.tributo},
          }
        ));

        tratamentosObrigatorios = [...tratamentosObrigatorios, ...novosTratamentos]

      })

      form.change(name, [...tratamentosObrigatorios]);
    }
  }, [fundamentosGrouped])


  const tratamentosProps = useMemo(
    () => ({
      name,
      columns: [
        {
          field: 'tributo',
          headerName: 'Tributo',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => `${row?.tributo?.codigo} - ${row?.tributo?.nome}`,
        },
        {
          field: 'regime',
          headerName: 'Regime Tributário',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => `${row?.regime?.codigo} - ${row?.regime?.nome}`,
        },
        {
          field: 'fundamento',
          headerName: 'Fundamento Legal Opcional',
          type: 'string',
          flex: 300,
          valueGetter: ({ row }) => `${row?.fundamento.id} - ${row?.fundamento.nome}`,
        },
      ],
    }),
    []
  );

  const tratamentosFormProps = useMemo(
    () => ({
      rootName: `ignorableFields.tratamentos`,
      fields: [],
    }),
    []
  );



  return (
    <>
      <QCXFinalBondManager
        isParentConsult={disabled}
        listProps={tratamentosProps}
        formProps={tratamentosFormProps}
        readOnlyMode
        disableRemove
        hideDeleteButton
      >
        <></>
      </QCXFinalBondManager>
    
    </>
  );
}